import React, { useState } from 'react';
import Mascot from '../components/Mascot';

const MascotShowcase = () => {
  const [mascotType, setMascotType] = useState('shiba');
  const [accessory, setAccessory] = useState(null);

  const types = ['blob', 'shiba', 'fitbot', 'cat', 'kettlebell'];
  const accessories = [null, 'accessory_glasses', 'accessory_headband', 'accessory_crown', 'accessory_necklace'];

  return (
    <div className="card" style={{ textAlign: 'center', marginTop: '2rem' }}>
      <h2>Test Animations Compagnons (Composant Réel)</h2>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginBottom: '1rem' }}>
        {types.map(t => (
          <button key={t} className={`btn ${mascotType === t ? 'btn-primary' : 'btn-outline'}`} onClick={() => setMascotType(t)}>{t}</button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginBottom: '2rem', flexWrap: 'wrap' }}>
        {accessories.map(a => (
          <button key={a || 'none'} className={`btn ${accessory === a ? 'btn-primary' : 'btn-outline'}`} onClick={() => setAccessory(a)}>
            {a ? a.replace('mascot_acc_', '') : 'Aucun'}
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem', border: '1px dashed var(--border-color)', borderRadius: '12px' }}>
         <Mascot id={`mascot_${mascotType}`} level={5} size={300} previewAccessory={accessory} />
      </div>
      <p className="mt-3 text-secondary">Clique sur le compagnon ci-dessus pour le voir s'animer !</p>
    </div>
  );
};

export default MascotShowcase;
